module.exports = __webpack_public_path__ + "static/media/td.983e8a4c.svg";